export interface CircleCheckIconProps {
  /**
   * Size of the icon in pixels
   * @default 16
   */
  size?: number;
  /**
   * Color of the icon
   * @default '#3F3F46'
   */
  color?: string;
  /**
   * Additional CSS class name
   */
  className?: string;
}

/**
 * CircleCheckIcon - An open circle with a checkmark icon
 * Used for indicating completion, quality checks, or success states.
 */
const CircleCheckIcon = ({
  size = 16,
  color = "#3F3F46",
  className,
}: CircleCheckIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.92314 10.6486L5.09647 7.82334L6.03647 6.88381L7.92314 8.76953L13.0965 3.66542L14.0431 4.60495L7.92981 10.6486H7.92314Z"
        fill={color}
      />
      <path
        d="M13.2606 7.29694C13.294 7.53015 13.314 7.76337 13.314 8.00325C13.314 10.9351 10.934 13.3139 8.00065 13.3139C5.06732 13.3139 2.68732 10.9351 2.68732 8.00325C2.68732 5.07138 5.06732 2.69257 8.00065 2.69257C9.14065 2.69257 10.194 3.05239 11.0607 3.66542L12.0273 2.69924C10.9073 1.84633 9.51398 1.33325 8.00065 1.33325C4.32065 1.33992 1.33398 4.32509 1.33398 8.00325C1.33398 11.6814 4.32065 14.6666 8.00065 14.6666C11.6807 14.6666 14.6673 11.6814 14.6673 8.00325C14.6673 7.36357 14.574 6.74388 14.4007 6.15751L13.2606 7.29694Z"
        fill={color}
      />
    </svg>
  );
};

CircleCheckIcon.displayName = "CircleCheckIcon";

export default CircleCheckIcon;
